import makeStyles from '@mui/styles/makeStyles';

// constants
import { SPACING, SPACING_HALF, SPACING_LEAST } from 'constants/spacing';

// components
// import AppBar from 'components/Layouts/AppBar';


// lib
import withAuth from 'lib/withAuth';

// hooks
// import { useIsAdmin } from 'providers/UserProvider';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    backgroundColor: theme.palette.common.white,
  },
  toolbar: theme.mixins.toolbar,
  content: ({ isAdmin }) => {
    return {
      width:'100%',
      padding: theme.spacing(SPACING, SPACING_HALF),
      height: '100%',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        padding: theme.spacing(SPACING, SPACING_LEAST),
      },
    };
  },
  themeButton: {
    position: 'fixed',
    bottom: theme.spacing(SPACING_HALF),
    right: theme.spacing(SPACING_HALF),
    zIndex: theme.zIndex.speedDial,
  },
}));

/**
 * @component DefaultTemplate
 */
function DefaultTemplate({ children }) {
  // const isAdmin = useIsAdmin();
  const classes = useStyles();


  return (
    <div className={classes.root}>
      {/* <AppBar /> */}
      <div className={classes.content}>
        <div className={classes.toolbar} />
        {children}
      </div>
    </div>
  );
}

export default withAuth(DefaultTemplate);
